import React, { useEffect } from 'react';
import {Routes, Route, Navigate} from 'react-router-dom';
import { observer } from 'mobx-react';
import TrainingView from './TrainingView';
import { useStores } from '../../hooks/use-stores';
import TrainingsList from './TrainingsList';
import HomeViewContainer from '../Home/HomeViewContainer';

export default observer(({ companyId, isTrainingEnabled, currentCompany }) => {
    const { store, trainingStore } = useStores();
    const { commonStore } = useStores();
    const { effectiveLanguages: availableLanguages } = commonStore;
    useEffect(() => {
        store.resetContext();
    }, [companyId, store]);

    const language = store.language;
    if ( currentCompany && !isTrainingEnabled ){
        return <Navigate to="/" />
    }

    if (currentCompany) {
        return  <Routes>
                <Route
                    index
                    element={<HomeViewContainer
                            layoutTitle="Awareness and Compliance Training"
                            code={'trainings'}
                            pageTitle={'training programs'}
                            content={<TrainingsList />}
                        />
                    }
                />
                <Route
                    path={`/:trainingId/*`}
                    element={
                        <TrainingView
                            availableLanguages={availableLanguages}
                            store={store}
                            trainingStore={trainingStore}
                            videoTokenStore={store}
                            language={language}
                            isDemo={false}
                        />
                    }
                />
            </Routes>

    } else {
        return null;
    }
});
